import { IDealStatusOption } from './models/IDealStatusOption'

export const OPTIONS: IDealStatusOption[] = [
  {
    title: 'Won',
    value: 'won',
  },
  {
    title: 'Lost',
    value: 'lost',
  },
]
